const style = {};

style.content = {
    marginLeft: '200px',
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingTop: '79px'
};

style.appMenu = {
    marginTop: '61px',
    width: '200px'
};

export default style;